import { InboxOutlined } from '@ant-design/icons';
import { Alert, UploadProps } from 'antd';
import { Progress } from 'antd';
import { message, Upload } from 'antd';
import { useState, useEffect } from "react";
import { Col, Row } from "antd";
import './FileUploader.scss';
import axios from "axios";
import { convertToObjectKeyString, TranslateString } from 'Utils/Common';
import { useIntl } from 'react-intl';
import UserService from 'services/UserService';

const { Dragger } = Upload;
interface FileUploaderProps {
	accept?: string;
	maxCount?: number;
	defaultFileList?: any;

	dataFor: any;
	getAllImportListFunc: any;
	setModalShow: any;
}

const url = process.env.REACT_APP_API_URL_IMPORT + "uploadCsvAccounts";

const FileUploader = (props: FileUploaderProps) => {
	const intl=useIntl();
	const [file, setFile] = useState<any>({});
	const [fileUploadResponse, setUploadResponse] = useState<any>({});
	const [fileUploadProgress, setUploadProgress] = useState<any>(0);
	const [fileUploadProgressStatus, setUploadProgressStatus] = useState<any>('');
	const [errorMsg, seterrorMsg] = useState<any>('');
    const [loading,setLoading] = useState<any>(false)

	useEffect(() => {
		setFile([])
		setUploadResponse([]);
	}, [props])


	let dragProps: UploadProps = {
		...props,
		name: 'file',
		multiple: false,
		action: url,
		headers:{
			Authorization : `Bearer ${UserService.getToken()}`
		},
		data: {
			type: 'validate',
			entity_type: props.dataFor
		},
		onChange(info) {
			seterrorMsg('')
			const { status } = info.file;
			if (status !== 'uploading') {
				console.log(info.file, info.fileList);

			}
			if (status === 'done') {
				if (info?.file?.response?.code === 200) {
					setUploadResponse(info?.file?.response);
					message.success(`${info.file.name} ` + TranslateString('file validated successfully.'));
				} else if (info?.file?.response?.code === 500) {
					message.error(info?.file?.response?.message);
					seterrorMsg(info?.file?.response?.msg)
				} else {
					message.error(`${info.file.name} ` + TranslateString('file validation failed.'));
				}
			} else if (status === 'error') {
				message.error(info?.file?.response?.message);
				setUploadProgress(0);
				setUploadProgressStatus('');
			}

		},
		onDrop(e) {
			console.log('Dropped files', e.dataTransfer.files);
		},
		beforeUpload(file, fileList) {
			// Access file content here and do something with it
			setFile(file)
			setUploadProgress(0);
			setUploadProgressStatus('');
			// Prevent upload
			// return false;
		}
	};



	const onFinish = async () => {
		try {
			let values = new FormData();
			values.append("file", file);
			values.append("type", "upload");
			values.append("entity_type", props.dataFor);

			setUploadProgressStatus('active');
			let steps = 0;
			let myInterval = setInterval(() => {
				steps += 5;
				if (steps < 101) {
					setUploadProgress(steps);
				} else {
					clearInterval(myInterval);
				}
			}, 300);

			setLoading(true);
			let headers:any= {
				headers: {
					"Authorization" : `Bearer ${UserService.getToken()}`,
					"Content-Type": "multipart/form-data",
				}
			}
			const resp = await axios.post(
				url, 
				values,
				headers
			);  

			if (resp?.data?.code === 200) {
				setLoading(false);
				setUploadProgress(100);

				setUploadProgress(0);
				props.setModalShow(false)
				
				setFile([])
				setUploadResponse([]);
				props.getAllImportListFunc();
				message.success(intl.formatMessage({id: convertToObjectKeyString("file uploaded successfully.")}));
			} else {
				setLoading(false);
				setUploadProgress(0);
				setUploadProgressStatus('exception');
			}
		} catch (errInfo) {
            setLoading(false);
			setUploadProgress(0);
			setUploadProgressStatus('exception');
			console.log('Error:', errInfo);
		}
	};



	return (
		<>
			<Row >
				{errorMsg && <Col md={24} className='mb-2'>
					<Alert message={errorMsg} type="error" showIcon style={{ paddingTop: 0, paddingBottom: 0, borderBottom: "none" }} />
					<Alert message="Please fix this and try again" type="warning" showIcon style={{ paddingTop: 0, paddingBottom: 0, borderTop: "none" }} />
				</Col>}
				<Col md={24} style={{ marginBottom: '40px', display: fileUploadResponse?.data?.recordCount > 0 ? 'none' : 'block' }}>
					<Dragger
						{...dragProps}
						className="text-center"
					>
						<p className="ant-upload-drag-icon">
							<InboxOutlined />
						</p>
						<p className="ant-upload-text">{TranslateString('Click or drag file to this area to upload')}</p>
						<p className="ant-upload-hint">
							{TranslateString('Support for a single upload. Strictly prohibit from uploading company data or other band files')}
						</p>
					</Dragger>
				</Col>
				<Col md={24} style={{ marginBottom: '40px', display: fileUploadResponse?.code === 200 ? 'block' : 'none' }} className='cu-text-center'>
					<div className='h5'> {TranslateString('Total Records')} : {fileUploadResponse?.data?.recordCount}</div>
					{fileUploadResponse?.data?.recordsrejected > 0 && <div className='h5'> {"Rejected Records"} : {fileUploadResponse?.data?.recordsrejected}</div>}

					{
						fileUploadProgress > 0 ? <Progress percent={fileUploadProgress} size="small" status={fileUploadProgressStatus} /> : ''
					}

					<button type="submit" disabled={loading} onClick={() => onFinish()} className="btn cu-btn-green rounded-0">
						{loading?TranslateString("Please Wait"):TranslateString('Submit')}
					</button>
				</Col>
			</Row>
		</>
	);
}

FileUploader.defaultProps = {
	accept: "*",
	defaultFileList: [],
	maxCount: 1,
};

export default FileUploader;